<template>
    <div class="coldContainer" :class="{'coldContainerDark' : isDark}">
        <TitleBar title="Margin模型" :txt="txt" :type="type"></TitleBar>
        <div class="coldBox">
            <div class="coldCard left" @click="goModelList">
                <p class="margin">{{marginLeft.home_team_name}}<span v-if="marginData.is_pay === 0">{{marginLeft.home_team_score}}</span></p>
                <p class="margin">{{marginLeft.away_team_name}}<span v-if="marginData.is_pay === 0">{{marginLeft.away_team_score}}</span></p>
                <div class="btm">
                    <span class="league" :style="{color: marginLeft.sclass_color}">{{marginLeft.sclass_name}}</span>
                    <span class="time">{{matchTimeLeft}}</span>
                </div>
                <div class="result">
                    <p v-if="marginData.is_pay === 0" class="odds">
                        <img v-if="marginLeft.home_team_score > marginLeft.away_team_score" src="../../assets/img/datamodel/homewin.png" />
                        <img v-if="marginLeft.home_team_score < marginLeft.away_team_score" src="../../assets/img/datamodel/guestwin.png" />
                        <img v-if="marginLeft.home_team_score === marginLeft.away_team_score" src="../../assets/img/datamodel/stand.png" />
                    </p>
                    <p v-else class="val margin">{{recommendLeft}}</p>
                    <p v-if="marginData.is_pay === 0">赛果命中</p>
                    <p v-else>推荐赛果</p>
                </div>
            </div>
            <div class="coldCard" @click="goModelList">
                <p class="margin">{{marginRight.home_team_name}}<span v-if="marginData.is_pay === 0">{{marginRight.home_team_score}}</span></p>
                <p class="margin">{{marginRight.away_team_name}}<span v-if="marginData.is_pay === 0">{{marginRight.away_team_score}}</span></p>
                <div class="btm">
                    <span class="league" :style="{color: marginRight.sclass_color}">{{marginRight.sclass_name}}</span>
                    <span class="time">{{matchTimeRight}}</span>
                </div>
                <div class="result">
                    <p v-if="marginData.is_pay === 0" class="odds">
                        <img v-if="marginRight.home_team_score > marginRight.away_team_score" src="../../assets/img/datamodel/homewin.png" />
                        <img v-if="marginRight.home_team_score < marginRight.away_team_score" src="../../assets/img/datamodel/guestwin.png" />
                        <img v-if="marginRight.home_team_score === marginRight.away_team_score" src="../../assets/img/datamodel/stand.png" />
                    </p>
                    <p v-else class="val margin">{{recommendRight}}</p>
                    <p v-if="marginData.is_pay === 0">赛果命中</p>
                    <p v-else>推荐赛果</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleBar from './common/titleBar.vue'
export default {
    name: 'marginCorpus',
    props: ['marginData'],
    components: {
        TitleBar
    },
    watch: {
        data: {
            handler () {
                this.renderDisList();
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    data () {
        return {
            type: "23",
            txt: '',
            marginLeft: {},
            marginRight: {},
            matchTimeLeft: '',
            matchTimeRight: '',
            recommendLeft: '', // 推荐赛果
            recommendRight: ''
        }
    },
    methods: {
        renderDisList () {
            if (this.marginData) {
                this.marginLeft = this.marginData.list[0];
                this.marginRight = this.marginData.list[1];
                this.matchTimeLeft = this.marginData.list[0].match_time.substring(5, 16).replace('-', '月');
                this.matchTimeRight = this.marginData.list[1].match_time.substring(5, 16).replace('-', '月');
                if (this.marginData.summery && this.marginData.summery.text * 1 > 0) {
                    this.txt = '（' + this.marginData.summery.subtext + this.marginData.summery.text + this.marginData.summery.text_unit + '）';
                } else {
                    this.txt = '';
                }
                if (this.marginLeft) {
                    if (this.marginLeft.predict_first === '1') {
                        this.recommendLeft = '主胜';
                    } else if (this.marginLeft.predict_first === '2') {
                        this.recommendLeft = '客胜';
                    } else if (this.marginLeft.predict_first === '3') {
                        this.recommendLeft = '平局';
                    }
                    if (this.marginLeft.predict_second === '1') {
                        this.recommendLeft += '、主胜';
                    } else if (this.marginLeft.predict_second === '2') {
                        this.recommendLeft += '、客胜';
                    } else if (this.marginLeft.predict_second === '3') {
                        this.recommendLeft += '、平局';
                    }
                }
                if (this.marginRight) {
                    if (this.marginRight.predict_first === '1') {
                        this.recommendRight = '主胜';
                    } else if (this.marginRight.predict_first === '2') {
                        this.recommendRight = '客胜';
                    } else if (this.marginRight.predict_first === '3') {
                        this.recommendRight = '平局';
                    }
                    if (this.marginRight.predict_second === '1') {
                        this.recommendRight += '、主胜';
                    } else if (this.marginRight.predict_second === '2') {
                        this.recommendRight += '、客胜';
                    } else if (this.marginRight.predict_second === '3') {
                        this.recommendRight += '、平局';
                    }
                }
            }
        },
        goModelList () {
            this.$emit('goDetail', this.type);
        }
    }
}
</script>
